<div class="h-100 w-100 content-center">
  <div class="d-inline-block">
    <h1>Not found</h1>
  </div>
</div>
